import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

const Content = styled(View)`
  display: flex;
  flex: 1;
  cursor: pointer;
`

const Touchable = ({ children, onClick }) => <Content onClick={onClick}>{children}</Content>

Touchable.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default Touchable
